import { useLayoutEffect, useState } from 'react';

/**
 * 初始化的时候传入需要隐藏文本的dom节点，内部判断是否超出可展示的行数
 * @param textDomList 多行文本dom节点的列表
 * @param lineNum 显示的行数
 * @param lineHeight 行高
 * @return {show:boolean,realHeight:number} 是否可展示，以及原本真实高度，可以用于高度动画
 */
export const useShowTextMore = ({
  textDomList,
  lineNum,
  lineHeight,
}: {
  textDomList: HTMLElement[];
  lineNum: number;
  lineHeight: number;
}) => {
  const [info, setInfo] = useState<Array<{ show: boolean; realHeight: number }>>([]);

  useLayoutEffect(() => {
    // 延迟获取高度是因为字体渲染会影响高度计算
    setTimeout(() => {
      if (!textDomList.length) return;
      const domsInfo = textDomList.map((descEle: HTMLElement) => {
        const descHeight = descEle.clientHeight;
        const show = descHeight > lineHeight * lineNum;
        descEle.style.height = show ? `${lineHeight * lineNum}px` : 'auto';

        return {
          show, // 最多展示两行
          realHeight: show ? descHeight + lineHeight : descHeight,
        };
      });

      setInfo(domsInfo);
    }, 500);
  }, [textDomList, lineNum, lineHeight]);

  return info;
};
